export const sanitizeInstagramUsername = (username: string) => {
  // Remove leading '@' and any invalid characters, then limit to 30 characters
  return username
    ?.replace(/^@/, '')
    .replace(/[^a-zA-Z0-9._]/g, '')
    .slice(0, 30);
};
